import { filter, pairwise } from 'rxjs/operators';
import { AfterViewInit,Input } from '@angular/core';
import { LAST_CATEGORY_SELECT_KEY, INDICATOR_DIRECTLY } from './../categories/categories.page';
import { StorageService } from './../../../../services/storage/storage.service';
import { KpiService } from 'src/app/services/kpi/kpi.service';
import { ActivatedRoute, Router, RoutesRecognized } from '@angular/router';
import { RouterService } from 'src/app/services/router/router.service';
import { LanguagesService } from 'src/app/services/languagesService/languages.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-indicators',
  templateUrl: './indicators.page.html',
  styleUrls: ['./indicators.page.scss'],
})
export class IndicatorsPage implements OnInit, AfterViewInit {
  categoryId
  hasDetails
  detail
  indicators = []
  ranking
  title:string;

  constructor(
    public languageService: LanguagesService,
    private router: RouterService,
    private route: ActivatedRoute,
    private kpiService: KpiService,
    private storage: StorageService
  ) { }

  async ngOnInit() {
    this.route.params.subscribe(params => {
      this.categoryId = params.idCategory
      this.getIndicatorsByCategory(params.idCategory)
    });

}

ngAfterViewInit(){
  this.storage.get(LAST_CATEGORY_SELECT_KEY).then((data) => {
    if (data) {
      if (data.description) {
        this.title= data.name;
        this.hasDetails = true
        this.detail = data.description;
        /* setTimeout(() => {
          document.getElementById('DetailCategory').innerHTML = data.description;
        }, 1000) */


      }
    }
  })
}

  async getIndicatorsByCategory(CategoryId){
  const indicators = await this.kpiService.getKpisByCategory(CategoryId)
  indicators.subscribe(async (data: any) => {
    this.indicators = data.data
    console.log(this.indicators)
    if (data.data.length == 1) {
        if (this.router.getPreviousUrl()?.includes(`app/kpi/categories/${this.categoryId}/indicators/indicator/`)) {
          this.router.navigate(`app/kpi/categories`)
        }else {
          this.ItemSelected(data.data[0])
        }
     
    }

  })
}

ItemSelected($event){
  this.router.navigate(`app/kpi/categories/${this.categoryId}/indicators/indicator/${$event.id}`)
}
}
